import request from '@/utils/request'

let Ma_training_categoryApi = {

  /*培训类别列表*/
  list(data) {
    return request._post('/shop/plus.ma_training_category.Index/index', data);
},
/*添加培训类别*/
add(data) {
    return request._post('/shop/plus.ma_training_category.Index/add', data);
},
/*修改培训类别*/
edit(data) {
    return request._post('/shop/plus.ma_training_category.Index/edit', data);
},
/*删除培训类别*/
del(data) {
    return request._post('/shop/plus.ma_training_category.Index/del', data);
},
/*培训类别详情*/
detail(data) {
  return request._post('/shop/plus.ma_training_category.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_training_category.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_training_category.Setting/getSetting', data, errorback);
    },
}
export default Ma_training_categoryApi;



// WEBPACK FOOTER //
// ./src/api/ma_training_category.js